// Every user of the portal is in Alberta, and the API judges "today" on Alberta's calendar, so the page takes the same
// day whatever zone the browser happens to be in; otherwise a browser elsewhere could offer a day the API refuses as
// the future, and the user would read the API's message instead of the field's.
export const ALBERTA_TIME_ZONE = 'America/Edmonton';

// The day a calendar in Alberta shows at an instant, by one formatter built once
const ALBERTA_CALENDAR = new Intl.DateTimeFormat('en-US', { timeZone: ALBERTA_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit' });
const readingAt = (instant) => Object.fromEntries(
    ALBERTA_CALENDAR.formatToParts(instant).filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)])
);

/** The calendar day in Alberta of an instant. */
export const albertaCalendarDay = (instant) => {
    const { year, month, day } = readingAt(instant);
    return { year, month, day };
};

/** Alberta's today, held as the browser's local midnight of that day, the way the date pickers hold a date. */
export const albertaToday = () => {
    const { year, month, day } = albertaCalendarDay(new Date());
    return new Date(year, month - 1, day);
};

/** The last millisecond of Alberta's today, held the same way. */
export const endOfAlbertaToday = () => {
    const { year, month, day } = albertaCalendarDay(new Date());
    return new Date(year, month - 1, day, 23, 59, 59, 999);
};
